// src/pages/UserProfile.js
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { db } from "../Firebase/Config";
import { collection, query, where, getDocs } from "firebase/firestore";

function UserProfile() {
  const { uid } = useParams();
  const [projects, setProjects] = useState([]);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Optional: fetch user profile details if you store them separately
    // Otherwise, skip this and just show UID
    // setUser(...)

    const fetchProjects = async () => {
      const q = query(collection(db, "estimates"), where("uid", "==", uid));
      const querySnapshot = await getDocs(q);
      const projectList = [];
      querySnapshot.forEach((doc) => {
        projectList.push({ id: doc.id, ...doc.data() });
      });
      setProjects(projectList);
    };
    fetchProjects();
  }, [uid]);

  return (
    <div style={{ padding: "2rem" }}>
      <h1>User Profile: {uid}</h1>
      <Link to="/edit-profile">Edit Profile</Link>
      <h2>Projects Submitted:</h2>
      <ul>
        {projects.map((proj) => (
          <li key={proj.id}>
            <Link to={`/project/${proj.id}`}>
              {proj.description.slice(0, 60) || "Untitled Project"}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default UserProfile;
